import { Edit } from "@mui/icons-material";
import { ReactElement } from "react";

import {
  AllIntegrationTypes,
  ListIntegrationsQuery,
} from "~frontend/__generated__/graphql";
import Table, { TableColumns } from "~frontend/components/Table";

import { integrationLabels } from "./types";

type IntegrationForList = ListIntegrationsQuery["listIntegrations"][0];

const columns: TableColumns<IntegrationForList> = [
  {
    title: "Name",
    key: "integrationName",
    renderValue: (row: IntegrationForList) => <span>{row.name}</span>,
  },
  {
    title: "Service",
    key: "integrationService",
    renderValue: (row: IntegrationForList) => (
      <span>{integrationLabels[row.service]}</span>
    ),
  },
  {
    title: "Created At",
    key: "createdAt",
    renderValue: (row: IntegrationForList) =>
      new Date(row.createdAt).toLocaleString(),
  },
];
export function IntegrationTable(props: {
  rows: IntegrationForList[];
  handleEditIntegration: React.Dispatch<
    React.SetStateAction<AllIntegrationTypes | null>
  >;
  handleDeleteIntegration: (integration: AllIntegrationTypes) => Promise<void>;
}): ReactElement {
  const { rows, handleEditIntegration } = props;
  return (
    <Table
      columns={columns}
      rows={rows}
      noFooter={true}
      rowActions={[
        {
          id: "edit-integration",
          type: "button",
          icon: <Edit />,
          tooltipLabel: "Edit Integration",
          onClick: integration =>
            handleEditIntegration(integration as AllIntegrationTypes),
        },
      ]}
    />
  );
}
